module.exports = __webpack_public_path__ + "static/media/register.a9fd6b57.png";